import { Route, Switch } from "react-router-dom";

import LdasProductCreateComponent from "../../components/page/ldas/create/LdasProductCreateComponent";
import LdasProductDetailComponent from "../../components/page/ldas/detail/LdasProductDetailComponent";
import LdasProductEditComponent from "../../components/page/ldas/edit/LdasProductEditComponent";
import LdasProductListComponent from "../../components/page/ldas/list/LdasProductListComponent";
import LdasLotDetailComponent from "../../components/page/ldas/lot-detail/LdasLotDetailComponent";

import "./ldasPage.scss";

const LdasPage = () => {
  return (
    <Switch>
      {/* <Redirect exact from="/ldas" to="/ldas/list" /> */}
      <Route exact path="/ldas/list" component={LdasProductListComponent} />
      <Route exact path="/ldas/create" component={LdasProductCreateComponent} />
      <Route
        exact
        path="/ldas/edit/:productId"
        component={LdasProductEditComponent}
      />
      {/* 로트 상세는 제품 상세보다 먼저 선언해야 exact 없이도 안전하게 매칭됨 */}
      <Route
        exact
        path="/ldas/detail/:productId/lot/:lotId"
        component={LdasLotDetailComponent}
      />
      <Route
        exact
        path="/ldas/detail/:productId"
        component={LdasProductDetailComponent}
      />
    </Switch>
  );
};

export default LdasPage;
